
 import adminUrls from "@/urls/admin";
import {
  sendDeleteRequest,
  sendGetRequest,
  sendPatchRequest,
  sendPostRequest
} from "@/helper/requests";
import {executeRequest} from "@/store/modules/utils";
 import {generateListUidToName} from "@/helper/uidToName";

const state = {
  permission: {
    currentUrl: null,
    items: [],
    loading: false,
    count: 0,
    detail: [],
    error: null,
  }
};

const getters = {
  getRole: state => state.permission.items,
  getRoleCount: state => state.permission.count,
  getCurrentUrl: state => state.permission.currentUrl,
  getRoleDetail: state => state.permission.detail,
  isLoadingRole: state => state.permission.loading,
  saveRoleError: state => state.permission.error,
};

const actions = {

  loadRoleList: ({commit, getters}, {url, urlAppend, finalizer=()=>{}, catcher=()=>{}}) => {
    if (!url) {
      url = adminUrls.ADMIN.PERMISSION.LIST()
      if (urlAppend) url = urlAppend(url)
    }
    if (!getters.isLoadingRole) {
      commit('SET_ROLE_LOADING');
      sendGetRequest(
        url, (data, url) => {
          for (let i in data['results']) {
               data['results'][i].fio= "-"
          }
          commit('SET_ROLE', data['results']);
          commit('SET_ROLE_COUNT', data['count']);
          commit('SET_ROLE_CURRENT_URL', url);
          commit('SET_ROLE_LOADING_END');
          finalizer(data, url);
        }, (data, url) => {
          commit('SET_ROLE_LOADING_END');
          commit('SAVE_ROLE_ERROR', data);
          catcher(data, url);
        }
      )
    }
  },

  createRole: ({dispatch, commit, getters}, {data, finalizer=()=>{}, catcher=()=>{}}) => {
    let url = adminUrls.ADMIN.PERMISSION.CREATE()
    executeRequest('Role', sendPostRequest, {url, data, finalizer, catcher}, {dispatch, commit, getters});
  },
  changeRole: ({dispatch, commit, getters}, {id,data, finalizer,catcher}) => {
    let url = adminUrls.ADMIN.PERMISSION.UPDATE(id)
    executeRequest('Role', sendPatchRequest, {url, data, finalizer, catcher}, {dispatch, commit, getters});
  },
  deleteRole: ({dispatch, commit, getters}, {id, finalizer, catcher}) => {
    let url = adminUrls.ADMIN.PERMISSION.DELETE(id)
    executeRequest('Role', sendDeleteRequest, {url, finalizer, catcher}, {dispatch, commit, getters});
  },

};

const mutations = {

  SET_ROLE: (state, obj) => {
    state.permission.items = obj
  },
  SET_ROLE_DETAIL: (state, value) => {
    state.permission.detail = value
  },
  SET_ROLE_COUNT: (state, value) => {
    state.permission.count = value
  },
  SET_ROLE_CURRENT_URL: (state, value) => {
    state.permission.currentUrl = value
  },
  SET_ROLE_LOADING: (state) => {
    state.permission.loading = true
  },
  SET_ROLE_LOADING_END: (state) => {
    state.permission.loading = false
  },
  SAVE_ROLE_ERROR: (state, error) => {
    state.permission.error = error
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}


